module.exports = __webpack_public_path__ + "static/media/wordpress.1c9d848e.svg";